import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import theme from './theme';
import { BrowserRouter } from "react-router-dom";
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
 

    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* SweetAlert nasce com z-index 1060, abaixo de modal (1300), snackbar
            (1400) e tooltip (1500) do MUI: a confirmação ficava atrás deles. */}
        <GlobalStyles styles={{ '.swal2-container': { zIndex: '2000 !important' } }} />
        <App />
      </ThemeProvider>
    </BrowserRouter>
 
);
